import { FC, PropsWithChildren } from 'react';

import { ContentHeader } from 'components';
import { NavigationLink } from 'components/NavigationLink';
import { useTranslation } from 'libs/i18n';
import { ROUTES } from 'libs/navigation';
import { Stack, Tab, Tabs } from 'libs/ui';

export interface SettingsViewProps extends PropsWithChildren {
  headerRightContent?: React.ReactNode;
  tabValue: 'timezone' | 'password' | 'notifications';
}

const LinkComponent = ({
  children,
  href,
  className,
}: { href: string; className?: string } & PropsWithChildren) => (
  <NavigationLink className={className} to={href}>
    {children}
  </NavigationLink>
);

export const SettingsView: FC<SettingsViewProps> = ({
  headerRightContent,
  children,
  tabValue,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Stack spacing={24}>
        <ContentHeader
          header={t('settings.title')}
          rightContent={headerRightContent}
        />
        <Tabs value={tabValue}>
          <Tab
            href={ROUTES.settings.timezoneSettings.fullPath}
            label={t('settings.tabs.timezone')}
            LinkComponent={LinkComponent}
            value="timezone"
          />
          <Tab
            href={ROUTES.settings.passwordSettings.fullPath}
            label={t('settings.tabs.password')}
            LinkComponent={LinkComponent}
            value="password"
          />
          <Tab
            href={ROUTES.settings.notificationsSettings.fullPath}
            label={t('settings.tabs.notifications')}
            LinkComponent={LinkComponent}
            value="notifications"
          />
        </Tabs>
      </Stack>
      {children}
    </>
  );
};
